import React, { useState, useEffect } from "react"
import { injectIntl } from "react-intl"
import Select, { Creatable } from "react-select"
import { Intl } from "../../../state/helpers/IntlProps"
import {
    ECOMMERCE_RULE_KEY,
    ECOMMERCE_RULE_VALUE_TYPE,
    getEcommerceRuleValueType
} from "../../../state/ecommerce-configuration/EcommerceRule"
import {
    RULE_VALUES_MESSAGES,
} from "../../../state/ecommerce-configuration/messages/EcommerceRuleMessages"

type Props = {
    intl: Intl,
    onUpdate: (values: string[]) => void,
    disabled: boolean,
    ruleKey: ECOMMERCE_RULE_KEY,
    values?: string[],
}

const EcommerceRuleValuesSelect = (props: Props) => {
    const [ruleKey, setRuleKey] = useState<string>(props.ruleKey)
    const [ruleValues, setRuleValues] = useState<string[]>(props.values || [])

    useEffect(() => {
        const newRuleKeyValueType = getEcommerceRuleValueType(props.ruleKey)
        if (newRuleKeyValueType !== getEcommerceRuleValueType(ruleKey)) {
            let defaultValues: string[] = []
            if (newRuleKeyValueType === ECOMMERCE_RULE_VALUE_TYPE.VALUE_TYPE_BOOLEAN) {
                defaultValues = ["true"]
            }

            setRuleValues(defaultValues)
            props.onUpdate(defaultValues)
        }

        setRuleKey(props.ruleKey)
    }, [props.ruleKey])

    const renderSelect = (ruleKey: string) => {
        switch (getEcommerceRuleValueType(ruleKey)) {
        case ECOMMERCE_RULE_VALUE_TYPE.VALUE_TYPE_BOOLEAN:
            let value = true
            if (ruleValues.length === 1) {
                if (typeof ruleValues[0] === "boolean") {
                    value = ruleValues[0]
                } else if (["true", "false"].includes(ruleValues[0])) {
                    value = ruleValues[0] === "true"
                }
            }

            return <Select
                value={value}
                multi={false}
                clearable={false}
                disabled={props.disabled}
                onChange={(selectedOption) => {
                    const newValues = [String(selectedOption.value)]
                    setRuleValues(newValues)
                    props.onUpdate(newValues)
                }}
                options={[
                    { label: props.intl.formatMessage(RULE_VALUES_MESSAGES.boolean_true), value: true },
                    { label: props.intl.formatMessage(RULE_VALUES_MESSAGES.boolean_false), value: false },
                ]}
            />
        case ECOMMERCE_RULE_VALUE_TYPE.VALUE_TYPE_STRING:
        default:
            return <Creatable
                multi
                placeholder={props.intl.formatMessage(RULE_VALUES_MESSAGES.placeholder)}
                value={ruleValues.map(v => {
                    return {
                        label: v,
                        value: v,
                    }
                })}
                onChange={(values) => {
                    const newValues = values.map(v => v.value)
                    setRuleValues(newValues)
                    props.onUpdate(newValues)
                }}
                options={[]}
                disabled={props.disabled}
            />
        }
    }

    return (
        <>
            {renderSelect(props.ruleKey)}
        </>
    )
}

export default injectIntl(EcommerceRuleValuesSelect)



// WEBPACK FOOTER //
// ./src/settings/ecommerce/components/EcommerceRuleValuesSelect.tsx